<script lang="ts">
	import { page } from '$app/stores';
	import * as m from '$lib/paraglide/messages';
	import { Seo } from '$lib/ui/atoms/Seo';
	import { TranslationFallbackBanner, WikiCta, WikiToc } from '$lib/features/wiki';
	import {
		buildWikiArticleJsonLd,
		buildWikiArticleSeo,
		buildWikiBreadcrumbJsonLd
	} from '$lib/features/wiki/logic/seo';
	import { wikiHref } from '$lib/features/wiki/logic/wiki-index';
	import { baseLocale } from '$lib/paraglide/runtime';

	let { data } = $props();

	const Content = $derived(data.component);
	const seo = $derived(
		buildWikiArticleSeo({
			locale: data.locale,
			fallback: data.fallback,
			realHrefs: data.seoAlternates
		})
	);
	const articleJsonLd = $derived(
		buildWikiArticleJsonLd({ page: data.page, canonicalPath: seo.canonicalPath })
	);
	const breadcrumbJsonLd = $derived(
		buildWikiBreadcrumbJsonLd({
			homeLabel: m.wiki_title(),
			homePath: wikiHref(data.locale),
			title: data.page.title,
			articlePath: $page.url.pathname
		})
	);
</script>

<Seo
	title={data.page.title}
	description={data.page.description}
	canonicalPath={seo.canonicalPath}
	hreflang={seo.hreflang}
	ogType="article"
	jsonLd={articleJsonLd}
/>
<svelte:head>
	{@html `<script type="application/ld+json">${JSON.stringify(breadcrumbJsonLd)}</script>`}
</svelte:head>

<div class="wiki-article-grid">
	<div class="wiki-article-main">
		{#if data.fallback}
			<TranslationFallbackBanner enHref={data.translations[baseLocale]} />
		{/if}

		<article class="prose wiki-prose wiki-article">
			<h1>{data.page.title}</h1>
			<Content />
		</article>

		<WikiCta pageId={data.page.pageId} />
	</div>
	<aside class="wiki-article-toc">
		<WikiToc />
	</aside>
</div>

<style>
	.wiki-article-grid {
		display: grid;
		grid-template-columns: minmax(0, 1fr);
		gap: 2rem;
	}
	.wiki-article-toc {
		display: none;
	}
	@media (min-width: 1280px) {
		.wiki-article-grid {
			grid-template-columns: minmax(0, 1fr) 200px;
		}
		.wiki-article-toc {
			display: block;
			position: sticky;
			top: 5rem;
			align-self: start;
		}
	}
</style>
